import { render } from "./Copyright.vue?vue&type=template&id=0d23de31"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lifet\\workspace\\cna\\cnanonsul-master\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__